import { StyleSheet } from "react-native";
import { Theme } from "../theme-provider";
import { colors } from "../../utils";

const detailsContentStyle = (theme: Theme) => StyleSheet.create({
    container: {
        paddingLeft: theme.spacing.sides,
        paddingRight: theme.spacing.sides,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: theme.spacing.sliver,
    },
    difficultyIcon: {
        width: theme.iconSize.medium,
        height: theme.iconSize.medium,
        marginRight: theme.spacing.half,
    },
    graphInfo: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: theme.spacing.half,
    },
    arrowIcon: {
        color: theme.color.textLink,
        width: theme.iconSize.small,
        height: theme.iconSize.small,
        marginLeft: theme.spacing.half,
        marginRight: theme.spacing.half,
    },
    leftGraphText: {
        width: '20%',
        textAlign: 'left',
    },
    rightGraphText: {
        width: '20%',
        textAlign: 'right',
    },
    share: {
        paddingLeft: theme.spacing.standard,
        marginLeft: 'auto',
        marginBottom: 'auto',
    },
    shareIcon: {
        color: theme.color.textLink,
        width: theme.iconSize.large,
        height: theme.iconSize.large,
        marginLeft: theme.spacing.half,
    },
    secondaryHeader: {
        flexShrink: 1,
        flexWrap: 'wrap',
    },
    paragraph: {
        paddingBottom: theme.spacing.standard,
    },
    capitalize: {
        textTransform: 'capitalize',
    },
    standard: {
        fontSize: theme.fontSize.standard,
    },
    medium: {
        fontSize: theme.fontSize.medium,
    },
    link: {
        color: theme.color.textLink,
    },
    underLine: {
        textDecorationLine: 'underline',
    },
    primary: {
        color: theme.color.textPrimary,
    },
    secondary: {
        color: theme.color.textSecondary,
    },
    imagesContainer: {
        paddingLeft:theme.spacing.sides,
    },
    separatorLine: {
        borderTopColor: colors.neutralColor50,
        borderTopWidth: theme.units.base * 0.1,
        paddingTop: theme.spacing.standard,
        paddingBottom: theme.spacing.standard
    },
    iconWrapper: {
        padding: theme.spacing.half,
    }
});

export { detailsContentStyle }